'use strict';
import { StorageService } from '../../../vue/services/StorageService'
export default class GlobalUtil {


    constructor(_paramQuery, config) {
        this.paramQuery = _paramQuery;
        this.config = config;

    }
    
    vibrate(values = [300]) {
        if ("vibrate" in navigator) {
            navigator.vibrate(values)
        }
    }


    getIsArray(array) {
        return Array.isArray(array);
    }
    getFirstPathSegment() {
        return window.location.pathname.split('/')[1];
    }
    getPathSegment(index) {
        return window.location.pathname.split('/')[index]
    }
    convertPaxesData(paxes) {
        const convertedData = paxes.reduce((accumulator, currentValue) => {
            accumulator.adults += currentValue.adults || 0;
            accumulator.children = accumulator.children.concat(currentValue.children || []);
            return accumulator;
        }, { adults: 0, children: [] });
        
        convertedData.rooms = paxes.length;
        return convertedData;
    }

    getUserKey() {
        const fn = window.__pt.fn;
        const ca_chat = `anonimo-${fn.generateUUID()}`;
        const cookieUserKey = fn.getCookie("__ca__chat") || ca_chat;
        const storedUserKey = StorageService.get('userKey');

        if (storedUserKey && !storedUserKey.includes('anonimo')) {
            return storedUserKey;
        }

        if (cookieUserKey) {
            StorageService.set('userKey', cookieUserKey);
            return cookieUserKey;
        }

        setTimeout(() => {
            const fallbackUserKey = fn.getCookie("__ca__chat") || ca_chat;
            StorageService.set('userKey', fallbackUserKey);
        }, 2000);

        return '';
    }

    getUserKeyFavorites() {
        let fn = window.__pt.fn;
        let _user = window.__pt.user || null;
        let ca_chat = `anonimo-${fn.generateUUID()}`;

        // Check user.firebaseId first
        let uKey = _user && _user.firebaseId ? _user.firebaseId : (fn.getCookie("session_id") || ca_chat);
        let storedUserKey = StorageService.get('userKey_fav');

        // If a userKey is stored and matches the current user's firebaseId, return it
        if (storedUserKey && storedUserKey === uKey) {
            return storedUserKey;
        }

        // If userKey is not stored or doesn't match the current user's firebaseId, update it
        if (uKey) {
            StorageService.set('userKey_fav', uKey);
            return uKey;
        }

        setTimeout(() => {
            let uKey = _user && _user.firebaseId ? _user.firebaseId : (fn.getCookie("session_id") || ca_chat);
            StorageService.set('userKey_fav', uKey);
        }, 2000);

        return '';
    }
    
    
    
  
    getPaxes(box) {
        let boxLength = box.pax && box.pax.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };

        for (let i = 0; box.pax && i < boxLength; i++) {
            const pax = box.pax[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}/`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `${pax.children.map(it => it.year).join(',')}`;
            } else {
                paxFormat += 'n';
            }

            paxes.paxesFormat.push(paxFormat);
        }

        return paxes;
    }
    getPaxesFavorites(box) {
        let boxLength = box && box.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };

        for (let i = 0; box && i < boxLength; i++) {
            const pax = box[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}/`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `${pax.children.map(it => it.year).join(',')}`;
            } else {
                paxFormat += 'n';
            }

            paxes.paxesFormat.push(paxFormat);
        }

        return paxes;
    }
    getPaxesRates(box) {
        let boxLength = box.pax && box.pax.length;
        let paxes = {
            adults: 0,
            children: 0,
            paxesFormat: []
        };
        for (let i = 0; box.pax && i < boxLength; i++) {
            const pax = box.pax[i];
            let paxFormat = "";
            paxes.adults += pax.adults;
            paxFormat += `${pax.adults}`;

            if (pax.children && pax.children.length) {
                paxes.children += pax.children.length;
                paxFormat += `|${pax.children.map(it => it.year).join(',')}`;
            }

            paxes.paxesFormat.push(paxFormat);
        }
        return paxes;
    }

    getPaxToMessages(newPax) { 
        return newPax.paxesFormat.map(rm => {
            const parts = rm.split('|');
            const adults = parts[0];
            const children = parts.length > 1 ? parts[1].split(',').join('_') : '';
            return `${adults}${children ? '_' : ''}${children}`;
        });
    }


    getAgeKids(box) {
        return (box.pax[0].children.map(item=>item.year)).join(',');
    }

    getShowPromotion(taxes) {
        var activeKey = false;
        var isBlackAndFriday = false;
        var isAniversario = false;
        var promotionType = null;
        var promotionsToShow = this.config.promotionKeyShow;
        if (promotionsToShow) {
            var promotionToFind = taxes ? promotionsToShow.find(x => x.key == taxes?.promotionType && x.active) : "";
            if (promotionToFind) {
                activeKey = promotionToFind.active;
                isBlackAndFriday = promotionToFind.blackFAndHotS;
                isAniversario = promotionToFind.isAniversary;
                // Determinar el tipo de promoción
                if (isBlackAndFriday) {
                    promotionType = 'blackandhost';
                } else if (isAniversario) {
                    promotionType = 'aniversario';
                }
            }
        }
        var responsePromotion = {
            activeKey: activeKey,
            HotSBlackFri: isBlackAndFriday,
            isAniversario: isAniversario,
            promotionType: promotionType
        }
        return responsePromotion;
    }

    windowScrollTop(){
        window.scrollTo(0, 0);
    }


    getCSFRToken() {
        let _token = "";
        let formAnti = document.getElementById('AntiForgeryToken');
        if (formAnti) {
            let csrfTokenInputAnti = formAnti.querySelector('input[name="_token"]');
            if (csrfTokenInputAnti && csrfTokenInputAnti.value) {
                _token = csrfTokenInputAnti.value;
            }
        }

        return _token;
    }
}
